import React from 'react'
import './header.css'
import CTA from './CTA'
import ME from '../../assests/IMG_0379.jpg'
import HeaderSocials from './HeaderSocials'
const Header = () => {
  return (
    <header>
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>James Schiavo</h1>
        <CTA />
        <HeaderSocials />
        <div className="me">
          <img src={ME} alt="My Image" className='me-image'/>
        </div>

      </div>
    
    </header>
  )
}

export default Header